const DEFAULT_OFFSET = {
  SKIDDING: 0,
  DISTANCE: 4,
};

export default DEFAULT_OFFSET;
